import defaults from 'lodash/defaults';
import { number } from '@atlassian/jira-common-url-transform-presets/src/index.tsx';
import { defaultIssueTypeSchemesFilter } from './packageName.constants.tsx';
import type {
	IssueTypeSchemeFilter,
	IssueTypeOrderBy,
	ApiQueryParams,
} from './IssueTypeScheme.types.tsx';
import { trimSearchFilter } from './trimSearchFilter.tsx';

const MAX_RESULTS = 10;

export const toUrlTransformer = (filter?: IssueTypeSchemeFilter) => {
	const { pageNumber, searchFilter, orderBy } = filter || {};
	return { pageNumber, searchFilter, orderBy };
};

export const fromUrlTransformer = (params: { [key: string]: string }): IssueTypeSchemeFilter => {
	const { pageNumber, searchFilter, orderBy } = params;
	const parsedNumber = Number.isNaN(number.parse(pageNumber))
		? defaultIssueTypeSchemesFilter.pageNumber
		: number.parse(pageNumber);
	const parsedOrderBy: IssueTypeOrderBy | undefined =
		orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
	return {
		...defaultIssueTypeSchemesFilter,
		pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
		searchFilter,
		orderBy: parsedOrderBy,
	};
};

export const toApiUrlTransformer = (filter: IssueTypeSchemeFilter): ApiQueryParams => {
	const fullFilter = defaults({}, filter, defaultIssueTypeSchemesFilter);
	let requestParams = {
		maxResults: MAX_RESULTS,
		// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
		startAt: (fullFilter.pageNumber - 1) * MAX_RESULTS,
		orderBy: fullFilter.orderBy,
		queryString: trimSearchFilter(fullFilter.searchFilter),
	};

	if (fullFilter.expand != null) {
		// @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
		requestParams = { ...requestParams, expand: fullFilter.expand.join(',') };
	}

	return requestParams;
};
